import { AxiosRequestConfig } from 'axios';
import siteContextStore from '@/shared/content/site-context.store';

const requestHandler = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const settings = siteContextStore.siteHeaders;
    settings.forEach(setting => {
        config.headers[setting.key] = setting.value;
    });
    return config;
};

export {
    requestHandler,
};
